import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import LineGraphMain from './graphInMainPopup/lineGraph/LineGraphMain';
import CircleGraphMain from './graphInMainPopup/circleGraph/CircleGraphMain';
import useGraphLogData from 'utils/customHook/useGraphLogData';
import { LegendContainer } from './MainPopup.css';

import { graphOrder, utmMap, reverseRangeMap } from 'utils/code';

const MainPopup = (props) => {
  const criterion = useSelector((store) => store.criterion)[props.engTitle]; // 각 탐지파트별 관리기준 설정
  const logData = useGraphLogData(props.title, props.moduleIdx);
  const lineData = logData === null ? [] : [...logData].reverse();

  if (!logData) {
    return null;
  }

  return (
    <div>
      <LineGraphMain data={lineData} criterion={criterion} {...props} />
      <CircleGraphMain criterion={criterion} {...props} />
      <LegendContainer>
        {graphOrder[props.moduleScn].map((key) => {
          return (
            <div className="contentBox" key={key}>
              <div className="title">법적관리기준(STEL)</div>
              <div>
                {criterion[key]
                  .filter((x) => x.standType === 'criterion')
                  .map((data) => {
                    if ([1, 15, 57].includes(data.criterionValueIdx)) {
                      return '-'
                    }
                    return `${data.standVal}${utmMap[key] === '' ? '' : `(${utmMap[key]})`}${reverseRangeMap[data.standRange]}`;
                  })
                  .join(' ')}
              </div>
              <div className='title'>법적관리기준(TWA)</div>
              <div>
                {criterion[key]
                  .filter((x) => x.standType === 'criterion')
                  .map((data) => {
                    if ([1, 15].includes(data.criterionValueIdx)) {
                      return '-'
                    } else if ([12].includes(data.criterionValueIdx)) {
                      return '30(ppm) 미만'
                    } else if ([9].includes(data.criterionValueIdx)) {
                      return '10(ppm) 미만'
                    } else if ([6].includes(data.criterionValueIdx)) {
                      return '0.5(%) 미만'
                    }
                    return `${data.standVal}${utmMap[key] === '' ? '' : `(${utmMap[key]})`}${reverseRangeMap[data.standRange]}`;
                  })
                  .join(' ')}
              </div>
            </div>
          );
        })}
      </LegendContainer>
    </div>
  );
};

export default React.memo(MainPopup);
